export const PHOTOS = {
  amina: '/static/images/people/a.jpg',
  aizhan: '/static/images/people/ai.jpg',
  galina: '/static/images/people/g.jpg',
  renat: '/static/images/people/r.jpg',
  nastya: '/static/images/people/n.jpg',
  albina: '/static/images/people/al.jpg'
}
